import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import '../App.css';

import Chat from './redux/containers/chat/Chat';
import Layout from './redux/containers/navbar/Layout';
import ProtectedRoute from './redux/containers/providers/ProtectedRoute';
import RoleBasedRoute from './redux/containers/providers/RoleBasedRoute';
import AuthInitializer from './redux/containers/providers/AuthInitializer';
import AccessDenied from './components/common/AccessDenied';
import TenantBasedHome from './redux/containers/providers/TenantBasedHome';

// custom views
import Logs from './redux/containers/logs/Logs';
import Marketing from './redux/containers/marketing/Marketing';
import Formularios from './redux/containers/respuestas/Respuestas';
import Dashboard from './redux/containers/dashboard/Dashboard';
import FaqDashboard from './redux/containers/faqDashboard/FaqDashboard';
import TenantUsers from './redux/containers/tenantUsers/TenantUsers';
import Surveys from './redux/containers/surveys/Surveys';
import Login from './redux/containers/login/Login';
import Landing from './redux/containers/landing/Landing';
import LandingDemo from './components/landing/LandingDemo';

import createStore from 'core/store';
import HTTPService from 'core/services/http';
import DataSource from 'core/services/dataSource';
import AuthService from 'core/services/authService';

const { REACT_APP_API_BASE_URL } = process.env;

const authService = new AuthService();
const http = new HTTPService(authService);

const dataSource = new DataSource({
  baseUrl: REACT_APP_API_BASE_URL,
  http,
});

const store = createStore({
  dataSource,
  authService,
});

const App = () => {
  return (
    <Provider store={store}>
      <AuthInitializer />
      <Router>
        <Routes>
          {/* Ruta pública para login */}
          <Route path="/login" element={<Login />} />
          {/* Ruta pública para landing demo */}
          <Route path="/demo" element={<LandingDemo />} />
          
          {/* Rutas protegidas con Layout */}
          <Route 
            path="/" 
            element={<ProtectedRoute homePath={true}><Layout /></ProtectedRoute>}
          >
            {/* Home page - redirige según tenant_id */}
            <Route index element={<TenantBasedHome />} />
            
            {/* Landing - accesible para todos los roles en tenant 3 y 5 */}
            <Route path="landing" element={
              <RoleBasedRoute allowedRoles={['Agente', 'Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Landing />
              </RoleBasedRoute>
            } />
            
            {/* Dashboard - accesible para Supervisor y Administrador */}
            <Route path="dashboard" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <FaqDashboard />
              </RoleBasedRoute>
            } />

            {/* Marketing-dashboard - accesible para Supervisor y Administrador */}
            <Route path="marketing-dashboard" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Dashboard />
              </RoleBasedRoute>
            } />
            
            {/* Logs - accesible para Supervisor y Administrador */}
            <Route path="logs" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Logs />
              </RoleBasedRoute>
            } />
            
            {/* Marketing - accesible para Supervisor y Administrador */}
            <Route path="marketing" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Marketing />
              </RoleBasedRoute>
            } />
            
            {/* Formularios - accesible para Supervisor y Administrador */}
            <Route path="formularios" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Formularios />
              </RoleBasedRoute>
            } />
            
            {/* Encuestas - accesible para Supervisor y Administrador */}
            <Route path="surveys" element={
              <RoleBasedRoute allowedRoles={['Supervisor', 'Administrador']} redirectTo="/access-denied">
                <Surveys />
              </RoleBasedRoute>
            } />
            
            {/* Chats - accesible para todos los roles */}
            <Route path="chats" element={
              <RoleBasedRoute allowedRoles={['Agente', 'Supervisor', 'Administrador']}>
                <Chat />
              </RoleBasedRoute>
            } />
            
            {/* Usuarios - accesible solo para Administrador */}
            <Route path="tenant-users" element={
              <RoleBasedRoute allowedRoles={['Administrador']} redirectTo="/access-denied">
                <TenantUsers />
              </RoleBasedRoute>
            } />
            
            {/* Página de acceso denegado */}
            <Route path="access-denied" element={<AccessDenied />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
